import * as types from "./types.js"
import * as api from "./api.js"


function fromTokenRequest() {
    return {
        type: types.TOKEN_REQUEST
    }
}

function fromTokenReceived(user) {
    return {
        type: types.TOKEN_RECEIVED,
        payload: user
    }
}

function fromTokenError(e) {
    return {
        type: types.TOKEN_ERROR,
        payload: e,
        error: true
    }
}

export function getUserFromToken(token) {
    return dispatch => {
        dispatch(fromTokenRequest())
        return api.getUserFromToken(token)
        .then(res => {
            if (res.status !== 200) {
                dispatch(fromTokenError(res.statusText))
            } else {
                return res.json()
                .then(user => dispatch(fromTokenReceived(user)))
            }
        })
    }
}


function postLoginRequest() {
    return {
        type: types.LOGIN_REQUEST
    }
}

function postLoginReceived(user) {
    return {
        type: types.LOGIN_RECEIVED,
        payload: user
    }
}

function postLoginError(e) {
    return {
        type: types.LOGIN_ERROR,
        payload: e,
        error: true
    }
}

export function login(email, pass) {
    return dispatch => {
        dispatch(postLoginRequest())
        return api.postLogin(email, pass)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postLoginError(res.statusText))
            } else {
                return res.json()
                .then(user => {
                    sessionStorage.setItem("token", user.token)
                    dispatch(postLoginReceived(user))
                })
            }
        })
    }
}

/*
 * CHANGE PASSWORD
 * 
 */
function changePasswordRequest() {
    return {
        type: types.CHANGE_PASSWORD_REQUEST
    }
}

function changePasswordReceived() {
    return {
        type: types.CHANGE_PASSWORD_RECEIVED,
        payload: {}
    }
}

function changePasswordError(e) {
    return {
        type: types.CHANGE_PASSWORD_ERROR,
        payload: e,
        error: true
    }
}

export function changePassword(id, oldpwd, newpwd) {
    return dispatch => {
        dispatch(changePasswordRequest())
        return api.changePassword(id, oldpwd, newpwd)
        .then(res => {
            if (res.status !== 200) {
                return res.text()
                .then(text => dispatch(changePasswordError(text)))
            } else {
                dispatch(changePasswordReceived())
            }
        })
    }
}

/*
 * RESET PASSWORD
 * 
 */
function resetPasswordRequest() {
    return {
        type: types.RESET_PASSWORD_REQUEST
    }
}

function resetPasswordReceived() {
    return {
        type: types.RESET_PASSWORD_RECEIVED,
        payload: {
            reset: true
        }
    }
}

function resetPasswordError(e) {
    return {
        type: types.RESET_PASSWORD_ERROR,
        payload: e,
        error: true
    }
}

export function resetPassword(id) {
    return dispatch => {
        dispatch(resetPasswordRequest())
        return api.resetPassword(id)
        .then(res => {
            if (res.status !== 200) {
                return res.text()
                .then(text => dispatch(resetPasswordError(text)))
            } else {
                dispatch(resetPasswordReceived())
            }
        })
    }
}

/*
 * DELETE PROFILE
 * 
 */
function deleteProfileRequest() {
    return {
        type: types.DELETE_PROFILE_REQUEST
    }
}

function deleteProfileReceived() {
    return {
        type: types.DELETE_PROFILE_RECEIVED
    }
}

function deleteProfileError(e) {
    return {
        type: types.DELETE_PROFILE_ERROR,
        payload: e,
        error: true
    }
}

export function deleteProfile(id) {
    return dispatch => {
        dispatch(deleteProfileRequest())
        return api.deleteProfile(id)
        .then(res => {
            if (res.status !== 200) {
                return res.text()
                .then(text => dispatch(deleteProfileError(text)))
            } else {
                sessionStorage.removeItem("token")
                dispatch(deleteProfileReceived())
            }
        })
    }
}

/*
 * SIGN UP
 * 
 */
const signupRequest = () => ({ type: types.SIGNUP_REQUEST })
const signupReceived = payload => ({ type: types.SIGNUP_RECEIVED, payload })
const signupError = payload => ({ type: types.SIGNUP_ERROR, payload, error: true })

export function signup(user) {
    return dispatch => {
        dispatch(signupRequest())
        return api.postSignup(user)
        .then(res => {
            if (res.status !== 200) {
                return res.text()
                .then(text => dispatch(signupError(text)))
            } else {
                dispatch(signupReceived({
                    signedup: true
                }))
            }
        })
    }
}


export function logout(id) {
    sessionStorage.removeItem("token")
    return dispatch => {
        dispatch({ type: types.LOGOUT })
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/user/actions.js
 **/